import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {ButtonContainer, Ok, Paragraph, Title, WrapperStyled} from './AllergyModal.style';
import {FormattedMessage} from 'react-intl';

export class AllergyModal extends PureComponent {
  render() {
    const {closeModalCallback} = this.props;

    return (
      <WrapperStyled>
        <Title><FormattedMessage id="checkout.allergyModalTitle" /></Title>
        <Paragraph><FormattedMessage id="checkout.allergyModalDescriptionP1" /></Paragraph>
        <Paragraph><FormattedMessage id="checkout.allergyModalDescriptionP2" /></Paragraph>
        <Paragraph><FormattedMessage id="checkout.allergyModalDescriptionP3" /></Paragraph>
        <ButtonContainer>
          <Ok onClick={closeModalCallback}>Ok</Ok>
        </ButtonContainer>
      </WrapperStyled>
    );
  }
}

AllergyModal.propTypes = {
  closeModalCallback: PropTypes.func
};

export default AllergyModal;



// WEBPACK FOOTER //
// ./components/AllergyModal/AllergyModal.js